import { Component, OnInit } from '@angular/core';
import { MixpanelService } from './services/mixpanel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

  constructor( private mixpanel: MixpanelService ) {}

  ngOnInit(): void {
    this.mixpanel.init();
  }
  
}
